import React from "react"
import { defPath } from '../config/defPath'
import NewHeader from "../components/layout/NewHeader"
import Modal from "../components/layout/modal"
import { useSession } from '../hooks/useState'

import { page as initRubigol3D } from "../pages/rubigol"
import Rubigol3D from "./rubigol"

export default function App() {

  const { validateSession } = useSession(state => state)

  const dataLayerLoad = () => {
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Content',
      'event_label': 'You ran out of lives',
      'interaction': 'true',
      'component_name': 'Modo_Carrera_Game',
      'element_text': 'Llegaste al máximo de partidas diarias',
    });

  }

  React.useEffect(() => {
    validateSession()
    dataLayerLoad()
    initRubigol3D()
  }, [])

  const handdleClickRegistro: React.MouseEventHandler<HTMLAnchorElement> = (event) => {
    event.preventDefault()
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'User Register Menu',
      'interaction': 'true',
      'component_name': 'User Register Menu',
      'element_text': 'Menú',
    });
    window.location.href = "/estadio-aguila/registro"
  }
  const handdleClickLogin: React.MouseEventHandler<HTMLAnchorElement> = (event) => {
    event.preventDefault()
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'User Login Menu',
      'interaction': 'true',
      'component_name': 'User Login Menu',
      'element_text': 'Menú',
    });
    window.location.href = "/estadio-aguila/iniciar-sesion"
  }

  return (
    <>
      <div className="gameInfo">
        <NewHeader />
        <Modal />
        <picture className="">
          <source className="" media="(min-width: 1024px)" srcSet={`${defPath}/assets/images/internNotice/bkLimit.jpeg`} />
          <img className="gameInfo--bk" src={`${defPath}/assets/images/bg-game.png`} alt="" />
        </picture>
        <div className="gameInfo__content">
          <h1 className="gameInfo__content--title">¡Fin del partido!</h1>
          {/* <h2 className="gameInfo__content--subtitle">LLEGASTE AL MÁXIMO DE PARTIDAS DIARIAS</h2> */}
          <p className="gameInfo__content--desc">Para continuar jugando debes iniciar sesión.</p>
          <div className="gameInfo__content-btns">
            <a className="ar__btn-primary" href="/estadio-aguila/registro" onClick={handdleClickRegistro}>Registrarme</a>
            <span className="gameInfo__content--link">
              ¿ya tienes cuenta? {' '}
              <a className="link-item" href='/estadio-aguila/iniciar-sesion' onClick={handdleClickLogin}>Inicia Sesión</a>
            </span>
          </div>
        </div>

        <div className={`canvas-rubygol-container is-visible`} style={{top: '4rem', zIndex: 6}}>
          <Rubigol3D />
        </div>
      </div>
    </>
  )
}
